import { getUrl, Post, Get, Put, Patch } from '.'

export const Search = async body => {
  return Post(getUrl('cnps.dfs.report.tpv.filter-transaction-tpv'), body)
}
export const filterMcTpvTxSummary = async body => {
  return Post(getUrl('cnps.dfs.report.filter-mc-tpv-tx-summary'), body)
}

export const filterMcTpvTxDetail = async body => {
  return Post(getUrl('cnps.dfs.report.filter-mc-tpv-tx-detail'), body)
}

export const GetMcIdFromMpos = async id => {
  return Get(getUrl('cnps.css.merchant-account.get-by-merchant-id-from-mpos', { id }))
}

export const detailTpvMcTransaction = async body => {
  return Post(getUrl('cnps.dfs.report.tpv.detail-tpv-mc-transaction'), body)
}
